/*
 * OBLIVION — prepaid offer, display only.   v1.0.0
 *
 * What it does: re-prints the estimated prepaid saving when the shopper switches
 * variant or the cart changes, from the figures Liquid already rendered.
 *
 * What it must never do, and what the code is arranged to make hard:
 *   - change a price, a line item, a cart total or anything at checkout. The only
 *     network call in this file is a GET of /cart.js.
 *   - say a discount was applied. GoKwik applies the real prepaid discount inside
 *     its own checkout; the theme cannot see it, so every figure is an estimate.
 *   - invent a figure. No price, no estimate: the message shows alone.
 *   - print a total when another discount is already on the cart, because the base
 *     GoKwik will work from is then unknown.
 *
 * The arithmetic mirrors snippets/oblivion-prepaid-estimate.liquid exactly and is
 * covered by tests that run both; neither may be changed alone.
 *
 * No MutationObserver, no polling, no interval: it updates on variant events, on
 * cart events, and once on load.
 */
(function () {
  'use strict';
  if (window.OblivionPrepaid && window.OblivionPrepaid.version) { window.OblivionPrepaid.refresh(); return; }

  var DEFAULTS = {
    enabled: false,
    discountType: 'fixed',
    discountValue: 0,
    maximumDiscount: 0,
    minimumOrderValue: 0,
    currency: 'INR',
    moneyFormat: 'Rs. {{amount}}',
    discountSource: 'gokwik',
    eligiblePaymentMethod: 'prepaid',
    codExcluded: true,
    stackable: false,
    showSavings: true,
    showPrepaidPrice: true,
    messageProduct: 'Pay prepaid and save',
    messageCart: 'Pay online and save',
    noteStacking: 'Additional prepaid savings depend on the offers already applied.',
    noteMixed: 'Some items in this cart are outside the prepaid offer, so the saving is not estimated here.',
    noteFooter: 'Applied by the payment provider at checkout, on prepaid payments only.',
    excludedProducts: [],
    collectionRulesActive: false,
    cartUrl: '/cart'
  };

  var config = null;
  var viewed = { product: false, cart: false };

  function readConfig() {
    if (config) return config;
    config = {};
    for (var key in DEFAULTS) { if (Object.prototype.hasOwnProperty.call(DEFAULTS, key)) config[key] = DEFAULTS[key]; }
    var el = document.getElementById('ob-prepaid-config');
    if (el) {
      try {
        var raw = JSON.parse(el.textContent);
        for (var k in raw) { if (Object.prototype.hasOwnProperty.call(raw, k) && raw[k] !== null && raw[k] !== undefined) config[k] = raw[k]; }
      } catch (e) { /* the defaults above still stand, and they show nothing */ }
    }
    window.OBLIVION_PREPAID_CONFIG = config;
    return config;
  }

  function qsa(sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); }
  function num(value) { var n = parseInt(value, 10); return isNaN(n) ? 0 : n; }

  /* ---------------- the estimate ---------------- */

  /**
   * amount and the result are in the shop's minor unit (paise), like Shopify's own
   * prices, so nothing here meets a float until it is formatted.
   * Returns 0 whenever the offer does not apply — never a negative, never a guess.
   */
  function estimate(amount, opts) {
    var cfg = readConfig();
    var stacked = !!(opts && opts.stacked);
    amount = num(amount);
    if (!cfg.enabled || amount <= 0 || !(cfg.discountValue > 0)) return 0;
    /* another discount is already on the cart: the base GoKwik uses is unknown */
    if (stacked && !cfg.stackable) return 0;
    if (cfg.minimumOrderValue > 0 && amount < cfg.minimumOrderValue * 100) return 0;

    var off;
    if (cfg.discountType === 'percentage') {
      off = Math.floor((amount * cfg.discountValue) / 100);
      var cap = cfg.maximumDiscount > 0 ? cfg.maximumDiscount * 100 : 0;
      if (cap > 0 && off > cap) off = cap;
    } else {
      off = Math.round(cfg.discountValue * 100);
    }
    if (off > amount) off = amount;
    return off > 0 ? off : 0;
  }

  /** Shopify money_format renderer: paise in, formatted string out. */
  function money(paise) {
    var cfg = readConfig();
    var parts = (Math.round(paise) / 100).toFixed(2).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return String(cfg.moneyFormat).replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      return name.indexOf('no_decimals') > -1 ? whole : whole + '.' + parts[1];
    });
  }

  /* ---------------- painting ---------------- */

  function setText(scope, sel, text) {
    qsa(sel, scope).forEach(function (el) { el.textContent = text; });
  }

  /**
   * Does this cart hold anything the offer excludes?
   * Product handles and ids are checked against /cart.js directly. Collection rules cannot
   * be: the cart payload carries no collections, so when they are configured every cart
   * counts as unverifiable and the figure stays off until the page renders again.
   */
  function cartHasIneligible(cart) {
    var cfg = readConfig();
    if (cfg.collectionRulesActive) return true;
    var banned = cfg.excludedProducts || [];
    if (!banned.length) return false;
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var handle = String(items[i].handle || '').toLowerCase();
      var id = String(items[i].product_id || '');
      for (var b = 0; b < banned.length; b++) {
        var one = String(banned[b]).toLowerCase();
        if (one && (one === handle || one === id)) return true;
      }
    }
    return false;
  }

  function paint(card, amount, opts) {
    var cfg = readConfig();
    var stacked = !!(opts && opts.stacked);
    var mixed = !!(opts && opts.mixed);
    var off = mixed ? 0 : estimate(amount, { stacked: stacked });
    var lines = card.querySelector('[data-prepaid-lines]');
    var note = card.querySelector('[data-prepaid-note]');

    if (off > 0) {
      setText(card, '[data-prepaid-save]', (card.getAttribute('data-prepaid-scope') === 'cart' ? '−' : '') + money(off));
      setText(card, '[data-prepaid-net]', money(amount - off));
      if (lines) lines.hidden = false;
      if (note) note.textContent = cfg.noteFooter;
    } else {
      /* no figure rather than a wrong one; the offer itself still stands */
      if (lines) lines.hidden = true;
      if (note) {
        note.textContent = mixed
          ? cfg.noteMixed
          : stacked
            ? cfg.noteStacking
            : cfg.minimumOrderValue > 0 && amount > 0 && amount < cfg.minimumOrderValue * 100
              ? 'On prepaid orders above ₹' + cfg.minimumOrderValue + '.'
              : cfg.noteFooter;
      }
    }
    return off;
  }

  /* ---------------- analytics: status only, no money and no customer ---------------- */

  function track(event, detail) {
    try {
      var payload = { event: event };
      if (detail) { for (var k in detail) { if (Object.prototype.hasOwnProperty.call(detail, k)) payload[k] = detail[k]; } }
      (window.dataLayer = window.dataLayer || []).push(payload);
    } catch (e) { /* analytics may never affect what the shopper sees */ }
  }

  /* ---------------- product ---------------- */

  function productCards() {
    return qsa('[data-oblivion-prepaid][data-prepaid-scope="product"]').filter(function (el) {
      return !(el.closest && el.closest('template, #quick-add-modal-content'));
    });
  }

  function priceOfVariant(card, variantId) {
    var json = card.querySelector('script[data-prepaid-variants]');
    if (!json) return null;
    var list;
    try { list = JSON.parse(json.textContent); } catch (e) { return null; }
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].id) === String(variantId)) return num(list[i].price);
    }
    return null;
  }

  /**
   * Re-print for a variant. A variant this card does not know about leaves the card
   * as it was rather than showing a figure for the wrong one.
   */
  function setVariant(variantId) {
    productCards().forEach(function (card) {
      var price = priceOfVariant(card, variantId);
      if (price == null) return;
      card.setAttribute('data-prepaid-variant', String(variantId));
      card.setAttribute('data-prepaid-price', String(price));
      paint(card, price, { stacked: false });
    });
  }

  /* ---------------- cart ---------------- */

  var cartTimer = null;
  function refreshCart() {
    var cards = qsa('[data-oblivion-prepaid][data-prepaid-scope="cart"]');
    if (!cards.length) return;
    if (cartTimer) clearTimeout(cartTimer);
    /* debounced: a quantity change fires several events in a row */
    cartTimer = setTimeout(function () {
      cartTimer = null;
      var cfg = readConfig();
      var url = String(cfg.cartUrl || '/cart').replace(/\/$/, '') + '.js';
      fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (cart) {
          if (!cart) return;
          var subtotal = num(cart.total_price);
          var stacked = num(cart.total_discount) > 0;
          var mixed = cartHasIneligible(cart);
          cards.forEach(function (card) {
            card.setAttribute('data-prepaid-subtotal', String(subtotal));
            card.setAttribute('data-prepaid-stacked', stacked ? 'true' : 'false');
            card.setAttribute('data-prepaid-mixed', mixed ? 'true' : 'false');
            paint(card, subtotal, { stacked: stacked, mixed: mixed });
          });
        })
        .catch(function () { /* leave what Liquid rendered: it was true when the page loaded */ });
    }, 250);
  }

  /* ---------------- wiring ---------------- */

  /* Horizon and most themes announce the variant; GemPages and the older sections
     only change the hidden input, so the change event is listened for as well. */
  document.addEventListener('variant:update', function (e) {
    var d = e.detail || {};
    var v = d.resource || d.variant;
    if (v && v.id != null) setVariant(v.id);
  });
  document.addEventListener('variant:change', function (e) {
    var v = (e.detail && (e.detail.variant || e.detail.resource)) || null;
    if (v && v.id != null) setVariant(v.id);
  });
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || !el.name || el.name !== 'id' || !el.value) return;
    setVariant(el.value);
  });
  document.addEventListener('cart:update', refreshCart);
  document.addEventListener('ob:cart:added', refreshCart);
  document.addEventListener('cart:refresh', refreshCart);

  document.addEventListener('click', function (e) {
    var cta = e.target && e.target.closest ? e.target.closest('[data-prepaid-cta]') : null;
    if (cta) track('prepaid_offer_clicked', { prepaid_placement: 'banner' });
  });

  function init() {
    var cfg = readConfig();
    if (!cfg.enabled) return;
    qsa('[data-oblivion-prepaid]').forEach(function (card) {
      if (card.dataset.prepaidInitialized === 'true') return;
      card.dataset.prepaidInitialized = 'true';
      var scope = card.getAttribute('data-prepaid-scope');
      if (scope === 'product') {
        paint(card, num(card.getAttribute('data-prepaid-price')), { stacked: false });
        if (!viewed.product) { viewed.product = true; track('prepaid_offer_viewed', { prepaid_placement: 'product' }); }
      } else if (scope === 'cart') {
        paint(card, num(card.getAttribute('data-prepaid-subtotal')), {
          stacked: card.getAttribute('data-prepaid-stacked') === 'true',
          mixed: card.getAttribute('data-prepaid-mixed') === 'true',
        });
        if (!viewed.cart) { viewed.cart = true; track('prepaid_offer_cart_viewed', { prepaid_placement: 'cart' }); }
      } else if (scope === 'banner' && !viewed.product) {
        track('prepaid_offer_viewed', { prepaid_placement: 'banner' });
      }
    });
  }

  /* a section re-render in the theme editor brings new nodes, which need painting */
  document.addEventListener('shopify:section:load', init);

  window.OblivionPrepaid = {
    version: '1.0.0',
    config: readConfig,
    estimate: estimate,
    money: money,
    setVariant: setVariant,
    refresh: function () { init(); refreshCart(); },
    /* deliberately absent: anything that could claim a discount was applied */
    init: init
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
